import React, { useState, useContext } from 'react';
import classNames from 'classnames';
import { ThemeContext } from 'styled-components';
import { createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';

import { faPen } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Typography } from '@comparethemarketau/manor-typography';
import { Link } from '@comparethemarketau/manor-link';

import { YourQuoteDetailsModal } from './your_quote_details_modal';

const useStyles = createUseStyles({
    updateLink: (theme) => ({
        color: theme.colors.primary500,
        fontWeight: theme.fontWeight.bold
    }),
    updateIcon: (theme) => ({
        marginLeft: theme.spacing[8],
        fontSize: theme.fontSize.base
    })
});

const ReviewAndEditYourDetails = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles(theme);
    const { className } = props;

    const [modalVisible, setModalVisible] = useState(false);

    const handleClick = (e) => {
        e.preventDefault();
        setModalVisible(true);
    };

    const handleModalClose = () => setModalVisible(false);

    return (
        <div
            className={classNames(
                'test-policySummary-edit', className)}
        >
            <Link
                handleClick={handleClick}
                underline="none"
                trackingLabel={'Link for review and edit your details'}
                className={classes.updateLink}
                role="button"
            >
                <Typography display="inline" variant="subtitle2">
                    Review and edit your details
                </Typography>
                <FontAwesomeIcon icon={faPen} className={classes.updateIcon} />
            </Link>
            <YourQuoteDetailsModal
                visible={modalVisible}
                onClose={handleModalClose}
            />
        </div>
    );
};

ReviewAndEditYourDetails.propTypes = {
    className: PropTypes.string
};

export { ReviewAndEditYourDetails };
